import { connect } from 'react-redux';
import ErrorView from '../../../features/error/ErrorView';
import config from '../../../configs/reading';

const mapStateToProps = state => {
    const { selectors } = config.root;
    return {
        isDemoModeOn: selectors.getIsDemoModeOn(state),
        hasError: selectors.hasErrorExcludingUnauthorized(state),
        error: selectors.getError(state),
    };
};

export default connect(mapStateToProps)(ErrorView);
